__turbopack_context__.v({
  "scrollBlock": "ScrollBlock-module__Pk5u9W__scrollBlock",
});
